// Task utility functions
export const TaskUtils = {
    /**
     * Check if task is completed
     */
    isCompleted: (task) => task.status === "complete",
    /**
     * Check if task is overdue
     */
    isOverdue: (task) => {
        if (!task.dueDate || TaskUtils.isCompleted(task))
            return false;
        return new Date(task.dueDate) < new Date();
    },
    /**
     * Check if task is due soon (within 24 hours)
     */
    isDueSoon: (task) => {
        if (!task.dueDate || TaskUtils.isCompleted(task))
            return false;
        const dueDate = new Date(task.dueDate);
        const now = new Date();
        const hoursUntilDue = (dueDate.getTime() - now.getTime()) / (1000 * 60 * 60);
        return hoursUntilDue <= 24 && hoursUntilDue > 0;
    },
    /**
     * Get task status display
     */
    getStatusDisplay: (status) => {
        const statusMap = {
            to_do: "To Do",
            in_progress: "In Progress",
            complete: "Complete",
        };
        return statusMap[status];
    },
    /**
     * Get task priority display
     */
    getPriorityDisplay: (priority) => {
        const priorityMap = {
            low: "Low",
            medium: "Medium",
            high: "High",
        };
        return priorityMap[priority];
    },
    /**
     * Get priority color class
     */
    getPriorityColor: (priority) => {
        const colorMap = {
            low: "text-green-600",
            medium: "text-yellow-600",
            high: "text-red-600",
        };
        return colorMap[priority];
    },
    /**
     * Get status color class
     */
    getStatusColor: (status) => {
        const colorMap = {
            to_do: "text-gray-600",
            in_progress: "text-blue-600",
            complete: "text-green-600",
        };
        return colorMap[status];
    },
    /**
     * Sort tasks by priority and due date
     */
    sortByPriorityAndDueDate: (tasks) => {
        const priorityOrder = {
            high: 3,
            medium: 2,
            low: 1,
        };
        return [...tasks].sort((a, b) => {
            // First sort by priority
            const priorityDiff = priorityOrder[b.priority] - priorityOrder[a.priority];
            if (priorityDiff !== 0)
                return priorityDiff;
            // Then by due date (earlier dates first)
            if (a.dueDate && b.dueDate) {
                return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
            }
            if (a.dueDate)
                return -1;
            if (b.dueDate)
                return 1;
            return 0;
        });
    },
    /**
     * Filter tasks by status
     */
    filterByStatus: (tasks, status) => tasks.filter((task) => task.status === status),
    /**
     * Filter overdue tasks
     */
    filterOverdue: (tasks) => tasks.filter(TaskUtils.isOverdue),
    /**
     * Get days until due
     */
    getDaysUntilDue: (task) => {
        if (!task.dueDate)
            return null;
        const dueDate = new Date(task.dueDate);
        const now = new Date();
        return Math.ceil((dueDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    },
};
